import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Title } from '../layout';
import { tenantHelpers } from '../tenantInfo';
import UploadLogoComponent from './upload-logo-component-folder/upload-logo.component';
import * as settingsActions from './settings.actions';

export class SettingsComponent extends Component {
  constructor(props) {
    super(props);

    this.onAddLogoData = this.onAddLogoData.bind(this);
    this.onAddLogoContent = this.onAddLogoContent.bind(this);
    this.onSaveLogo = this.onSaveLogo.bind(this);
  }

  onAddLogoData(name, contentType, size) {
    const { settingsActions } = this.props;
    settingsActions.addLogoData(name, contentType, size)
  }

  onAddLogoContent(content) {
    const { settingsActions } = this.props;
    settingsActions.addLogoContent(content)
  }

  onSaveLogo() {
    const { settingsActions, settings, tenant } = this.props;
    const { currentTenant } = tenant;
    var fName = settings && settings.newLogo && settings.newLogo.fileName;
    var fContentType = settings && settings.newLogo && settings.newLogo.fileContentType;
    var fileSize = settings && settings.newLogo && settings.newLogo.fileSize;
    var fileContent = settings && settings.newLogo && settings.newLogo.fileContent;
    var currentLogoUrl = currentTenant && currentTenant.logoUrl;

    if ( fName && fContentType && fileSize && fileContent ) {
      return settingsActions.doChangeLogo(fName, fContentType, fileSize, fileContent, currentLogoUrl);
    }
  }

  render() {
    const { settings, auth } = this.props;

    return (
      <div>
        <Title title={`Settings`}/>
        <h1>
          Settings
        </h1>
        <UploadLogoComponent
          onAddLogoData={this.onAddLogoData}
          onAddLogoContent={this.onAddLogoContent}
          onSaveLogo={this.onSaveLogo}
          newLogo={settings.newLogo}
          oldLogo={auth.currentSession.tenant.logoUrl}
          />
      </div>
    );
  }
}

SettingsComponent.propTypes = {
  settingsActions: PropTypes.any.isRequired
};

const mapStateToProps = ({settings, auth, tenant}) => {
  return {
    settings,
    auth,
    tenant
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    settingsActions: bindActionCreators(settingsActions, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SettingsComponent);
